<template>
  <div>
    <v-dialog v-model="dialog" width="340px" persistent @keydown.esc="$emit('fecharDialog')">
      <v-card>
        <v-card-title class="titulos">
          <v-icon class="mr-2">mdi-calendar</v-icon>
          Agendamento
          <v-spacer></v-spacer>
          <c-duvidas
            posicao="direita"
            titulo="Agendamento"
            texto="
            <ul>
              <li>O agendamento será executado uma vez ao dia durante uma semana.</li>
              <li>Novos agendamentos possuem prioridade sobre os recorrentes.</li>
              <li>A data limite para um agendamento é de três meses</li>
              <li>Os processos de agendamento podem ser cobrados a partir do 4º.</li>
            </ul>"
          ></c-duvidas>
        </v-card-title>
        <v-card-text class="listas">
          <v-form ref="form" @keypress.native.enter="verificarQualRequisicaoFazer()">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="agendamento.nome"
                  label="Nome"
                  :rules="[regras.campoObrigatorio]"
                  ref="nome"
                  validate-on-blur
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-dialog
                  ref="seletorDeData"
                  v-model="dialogSeletorDeData"
                  :return-value.sync="agendamento.data"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="formatarData"
                      label="Data"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules="[regras.campoObrigatorio]"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="agendamento.data"
                    locale="pt-br"
                    :min="bloquearDatasAnteriores"
                    :max="restringirMes"
                  >
                    <v-btn text color="error" @click="dialogSeletorDeData = false">cancelar</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.seletorDeData.save(agendamento.data)"
                    >OK</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters>
            <v-col cols="6" class="text-start">
              <v-btn color="error" text @click="$emit('fecharDialog')" :disabled="carregando">Cancelar</v-btn>
            </v-col>
            <v-col cols="6" class="text-end">
              <v-btn color="primary" text :loading="carregando" @click="verificarQualRequisicaoFazer()">Salvar</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import Duvidas from "./Duvidas";
import { enviar, editar } from "../../mixins/RequisicaoMixin";
import { headersPadrao } from "../../mixins/HeadersMixin";
import { bus } from "../../main";
import { mapState } from "vuex";

export default {
  data() {
    return {
      agendamento: {
        nome: "",
        data: ""
      },
      dialogSeletorDeData: false,
      regras: {
        campoObrigatorio: value => !!value || "Campo obrigatório"
      },
      carregando: false,
      requisicaoAhFazer: "POST"
    };
  },
  computed: {
    ...mapState(["idDoTemplate"]),
    formatarData() {
      return this.agendamento.data
        ? moment(this.agendamento.data).format("DD/MM/YYYY")
        : "";
    },
    restringirMes() {
      var mesMaximoParaSelecao = moment()
        .add(2, "months")
        .format();
      return mesMaximoParaSelecao;
    },
    bloquearDatasAnteriores() {
      var dataAtual = moment().format();
      return dataAtual;
    }
  },
  components: {
    "c-duvidas": Duvidas
  },
  methods: {
    async salvarAgendamento(){
      if(this.$refs.form.validate()){
        this.carregando = true;
        const url = "/api/v1/agendamentos";
        this.agendamento.idDoTemplate = this.idDoTemplate;
        await enviar(url, headersPadrao(), this.agendamento)
        .then(resposta => {
          this.agendamento.id = resposta.id;
          this.$store.commit("sucesso", "Agendamento cadastrado com sucesso.")
          this.$emit('fecharDialog');
          this.$emit("atualizarDadosDoAgendamento", true, resposta.id)
          this.$refs.form.reset();
        })
        .catch(erro => {
          if(erro.request.status == 400){
            this.$store.commit("atualizarMensagemDeErro", JSON.parse(erro.request.response).debugMessage);
            this.$store.commit("erro");
          }else this.$store.commit("erro", "Erro ao salvar agendamento.")
        })
        .finally(() => {
          this.carregando = false;
          this.requisicaoAhFazer = "POST";
        })
      }
    },
    async atualizarAgendamento(){
      this.carregando = true;
      const url = `/api/v1/agendamentos/${this.agendamento.id}`
      delete this.agendamento.id;
      await editar(url, headersPadrao(), this.agendamento)
      .then(resposta => {
        this.$store.commit("sucesso", "Agendamento atualizado com sucesso.")
        this.$emit('fecharDialog');
        if(this.requisicaoAhFazer == "PUT") bus.$emit("agendamentoEditado", resposta)
        this.requisicaoAhFazer = "POST";
      })
      .catch(erro => {
        if(erro.request.status == 400){
          this.$store.commit("atualizarMensagemDeErro", JSON.parse(erro.request.response).debugMessage);
          this.$store.commit("erro");
        }else this.$store.commit("erro", "Erro ao salvar agendamento.")
      })
      .finally(() => this.carregando = false)
    },
    verificarQualRequisicaoFazer(){
      if(this.requisicaoAhFazer == "PUT" || this.temAgendamento) this.atualizarAgendamento();
      else this.salvarAgendamento();
    }
  }, 
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    agendamentoPassado: {
      type: Object
    },
    temAgendamento: {
      type: Boolean,
      default: false
    },
    idDoAgendamento: {
      type: String,
      default: null
    }
  },
  watch: {
    dialog(val){
      if(val){
        setTimeout(() => {
          this.$refs.nome.focus();
        }, 50)
      }else{
        this.$refs.form.reset();
        this.agendamento.data = "";
      }
    },
    agendamentoPassado(agendamento){
      this.requisicaoAhFazer = "PUT";
      this.agendamento = agendamento;
    },
    idDoAgendamento(id){
      if(id != null) {
        this.agendamento.id = id;
      }
    }
  }
};
</script>

<style>
</style>